import DataItem from 'components/DataItem';
import { displayISODateTime } from 'shared/helpers/common';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function ToursItem({ tour, isLoyaltyTour }) {
  const { tourName, tourType, startDate, endDate, duration } = tour;
  const { whiteLabelSettings: { primaryColour } = {} } = useWhiteLabelSettings();
  const backgroundStyle = {
    backgroundColor: primaryColour || DEFAULT_PRIMARY_COLOUR,
  };

  return (
    <div className="pb-8 bg-white">
      <div style={backgroundStyle} className="mt-[40px] rounded-t-lg text-white text-xl font-bold">
        <div className="p-4 text-[24px] font-medium">
          <div>{tourName}</div>
        </div>
      </div>
      <div className="flex flex-wrap bg-white pt-2 pb-3 px-4 md:px-8">
        <DataItem label="Name" value={tourName} />
        {!isLoyaltyTour && (
          <>
            <DataItem label="Type" value={tourType} />
            <DataItem label="Start Date" value={displayISODateTime(startDate)} />
            <DataItem label="End Date" value={displayISODateTime(endDate)} />
            <DataItem label="Type" value={duration} />
          </>
        )}
      </div>
    </div>
  );
}
